import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { Box, Card, Typography, TextField, Button, Alert, FormControlLabel, Switch, Modal, Link } from '@mui/material';
import SignupModal from './SignupModal';
import axios from 'axios';

// Stile per la finestra modale
const modalStyle = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: '90%', maxWidth: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, p: 4,
};

const LoginForm = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  
  // Stato per il modale di reset password
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await auth.login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Credenziali non valide. Riprova.');
    }
  };

  const handleRequestReset = async () => {
    setResetMessage('');
    try {
      const res = await axios.post('/api/auth/request-password-reset', { email: resetEmail });
      setResetMessage(res.data.message);
    } catch (err) {
      setResetMessage('Si è verificato un errore. Riprova.');
    }
  };

  return (
    <>
      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 3 }}>
        <Typography variant="h5" component="h1" gutterBottom textAlign="center">Accedi</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField label="Email" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <TextField label="Password" type="password" variant="outlined" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <Button type="submit" variant="contained" size="large" sx={{ mt: 1 }}>Entra</Button>
        <Typography variant="body2" sx={{ textAlign: 'center', mt: 2 }}>
          <Link href="#" onClick={(e) => { e.preventDefault(); setResetModalOpen(true); }} underline="hover">
            Password dimenticata?
          </Link>
        </Typography>
      </Box>

      {/* Modale per la richiesta di reset password */}
      <Modal open={resetModalOpen} onClose={() => setResetModalOpen(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>Reimposta Password</Typography>
          {!resetMessage ? (
            <>
              <Typography variant="body2" color="text.secondary">
                Inserisci il tuo indirizzo email. Ti invieremo un link per creare una nuova password.
              </Typography>
              <TextField
                fullWidth
                margin="normal"
                label="Il tuo indirizzo email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
              <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={handleRequestReset}>Invia Link di Reset</Button>
            </>
          ) : (
            <Alert severity="success">{resetMessage}</Alert>
          )}
        </Box>
      </Modal>
    </>
  );
};

// ... Il resto del componente LandingPage rimane invariato ...
const LandingPage = () => {
    const [modalOpen, setModalOpen] = useState(false);
      const [registrationSuccess, setRegistrationSuccess] = useState(null); // { type: 'student' | 'business' }
  
    if (registrationSuccess) {
      return (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3 }}>
              <Card sx={{ p: 4, maxWidth: 500 }}>
                    <Typography variant="h5" textAlign="center">Registrazione Completata!</Typography>
                    {registrationSuccess.type === 'student' ? (
                      <Typography textAlign="center" sx={{ mt: 2 }}>
                        Grazie per esserti registrato. Il tuo account è già attivo: puoi accedere subito con le tue credenziali.
                      </Typography>
                    ) : (
                      <Typography textAlign="center" sx={{ mt: 2 }}>
                        Grazie per esserti registrato. Il tuo profilo è ora in attesa di approvazione da parte di un amministratore. Riceverai una notifica via email non appena sarà attivo.
                      </Typography>
                    )}
                    <Button fullWidth variant="contained" sx={{ mt: 3 }} onClick={() => setRegistrationSuccess(null)}>
                      Torna alla Home
                    </Button>
              </Card>
          </Box>
      );
    }
  
    return (
      <>
        <Box
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3 }}
        >
          <img src="https://www.fondazioneminoprio.it/wp-content/uploads/2025/04/Logo-Fondazione-Minoprio-ITS-Academy-300x103.png" alt="Logo" style={{ marginBottom: '2rem' }} />
          <Typography variant="h4" component="h1" textAlign="center" sx={{ maxWidth: '600px', mb: 1, fontWeight: 600 }}>Il Tuo Futuro Professionale Inizia Qui</Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary" sx={{ maxWidth: '600px', mb: 4 }}>
            Network Alumni & Partner: La piattaforma dedicata che unisce i nostri ex studenti alle aziende del network. Accedi o registrati per esplorare le opportunità e visualizzare i profili.
          </Typography>
  
          <Card sx={{ width: '100%', maxWidth: 400 }}>
            <LoginForm />
          </Card>
  
          <FormControlLabel
            control={<Switch onChange={() => setModalOpen(true)} />}
            label="Non sei registrato? Fallo ora"
            sx={{ mt: 2 }}
          />
        </Box>
  
        <SignupModal 
          open={modalOpen} 
          onClose={() => setModalOpen(false)} 
            onRegisterSuccess={(info) => {
              setModalOpen(false);
              setRegistrationSuccess(info || { type: 'student' });
            }} 
        />
      </>
    );
  };
  
export default LandingPage;